import { shutdown } from "@intercom/messenger-js-sdk";
import { getAccessToken } from "./storage-helpers";
import { AxiosInstance, InternalAxiosRequestConfig, AxiosHeaders, AxiosResponse } from 'axios';

export const createClient = (axiosInstance: AxiosInstance): AxiosInstance => {
    axiosInstance.interceptors.request.use(
        (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
            const token = getAccessToken();
            if (token) {
                if (!config.headers) {
                    config.headers = new AxiosHeaders(); // Ensure headers is defined
                }
                config.headers['x-access-token'] = token;
            }
            return config;
        },
        (error: any): Promise<never> => {
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        (response: AxiosResponse): AxiosResponse => {
            return response;
        },
        (error: any): Promise<never> => {
            if (error.response?.status === 401) {
                const currentPath = window.location.pathname;
                // Don't redirect on login/auth pages - let them handle the error themselves
                const isAuthPage = currentPath === '/auth/login' ||
                                   currentPath.startsWith('/at/') ||
                                   currentPath === '/welcome';

                if (!isAuthPage) {
                    localStorage.removeItem('user');
                    shutdown();
                    window.location.href = '/welcome';
                }
            }
            return Promise.reject(error);
        }
    );

    return axiosInstance;
};